import { OnboardingMessages } from './messages';

/**
 * Tradução em Português (Brasil) para o plugin de onboarding.
 */
export const ptBR: OnboardingMessages = {
  /* ── Cabeçalho das páginas ──────────────────────── */
  rolePageTitle: 'Onboarding do Desenvolvedor',
  rolePageSubtitle: 'Aprenda a navegar no IDP',
  trackPageSubtitle: 'Aprenda a navegar no IDP',

  /* ── Página de seleção de papel ─────────────────── */
  roleQuestion: 'Qual é o seu papel?',
  startAs: 'Começar como {{role}}',
  comingSoon: 'Em breve',

  /* ── Página de trilha ───────────────────────────── */
  changeRole: 'Trocar Papel',
  startJourney: 'Iniciar Jornada',
  reviewJourney: 'Revisar Jornada',
  warningMessage:
    'Você deve completar o processo de onboarding para usar a plataforma!',
  journeyLabel: 'Jornada {{index}}',
  stepsCount: '{{count}} passos',
  phasesCount: '{{count}} fases',
  journeysCount: '{{count}} jornadas',
  completed: 'Concluído',

  /* ── Modal de passo / overlay ───────────────────── */
  back: 'Voltar',
  continueLabel: 'Continuar',
  finish: 'Finalizar',
  stepIndicator: 'Passo {{current}}/{{total}}',

  /* ── Papéis ─────────────────────────────────────── */
  roleDeveloperTitle: 'Desenvolvedor',
  roleDeveloperDescription: 'Eu codifico e faço deploy do meu serviço',
  roleDeveloperDuration: '~70 min',
  roleDeveloperBadge: '+ Quiz',
  roleDeveloperPoint1: 'Navegar no Catálogo e encontrar serviços',
  roleDeveloperPoint2: 'Deploy do código até produção',
  roleDeveloperPoint3: 'Solucionar problemas de pipeline e runtime',

  roleTechLeadTitle: 'Tech Lead',
  roleTechLeadDescription:
    'Eu crio serviços e gerencio a infraestrutura do meu time',
  roleTechLeadDuration: '~75 min',
  roleTechLeadBadge: '+ Exame',
  roleTechLeadPoint1: 'Tudo da trilha de Desenvolvedor',
  roleTechLeadPoint2: 'Criar novos serviços a partir de templates',
  roleTechLeadPoint3:
    'Provisionar recursos Azure (KeyVault, Storage, EventHub)',
  roleTechLeadPoint4: 'Governança de API e scorecards',

  /* ── Títulos das jornadas ───────────────────────── */
  journeyNavigatingTitle: 'Navegando no IDP',
  journeyDeployTitle: 'Deploy: Do Código ao Ar',
  journeyTroubleshootTitle: 'Quando Algo Dá Errado',
  journeyTemplatesTitle: 'Criar novos serviços a partir de templates',
  journeyAzureTitle: 'Provisionar recursos Azure',
  journeyApiTitle: 'Governança de API e scorecards',
  journeyTeamTitle: 'Gestão de Time e Permissões',
  journeyCostTitle: 'Otimização de Custos e Monitoramento',

  /* ── Descrições das jornadas ────────────────────── */
  journeyNavigatingDesc:
    'Entenda o portal, encontre seu projeto e aprenda as ferramentas e regras.',
  journeyDeployDesc:
    'Aprenda como fazer deploy dos seus serviços do código até produção.',
  journeyTroubleshootDesc:
    'Solucione problemas de pipeline e runtime de forma eficaz.',
  journeyTemplatesDesc:
    'Crie novos serviços e componentes usando templates predefinidos.',
  journeyAzureDesc:
    'Configure e gerencie recursos de nuvem Azure para o seu time.',
  journeyApiDesc:
    'Garanta a qualidade e conformidade das APIs com scorecards de governança.',
  journeyTeamDesc:
    'Gerencie os membros do seu time e configure permissões de acesso.',
  journeyCostDesc:
    'Monitore custos e otimize o uso de recursos nos seus serviços.',

  /* ── Durações das jornadas ──────────────────────── */
  journeyNavigatingDurationDev: '~15 min',
  journeyNavigatingDurationTL: '~10 min',
  journeyDeployDuration: '~45 min',
  journeyTroubleshootDuration: '~10 min',
  journeyTemplatesDuration: '~10 min',
  journeyAzureDuration: '~15 min',
  journeyApiDuration: '~15 min',
  journeyTeamDuration: '~10 min',
  journeyCostDuration: '~10 min',

  /* ── Nomes das fases — Navegando no IDP ─────────── */
  phaseWelcome: 'Boas-vindas e Visão da Plataforma',
  phaseNavigating: 'Navegando no Backstage',
  phaseFinding: 'Encontrando Seu Projeto',
  phaseExternal: 'Visão das Ferramentas Externas',
  phasePermissions: 'Permissões e Regras de Segurança',

  /* ── Nomes das fases — Deploy ───────────────────── */
  phasePipeline: 'Visão da Pipeline',
  phaseBuild: 'Build e Testes',
  phaseStaging: 'Deploy para Staging',
  phaseProduction: 'Promoção para Produção',
  phaseMonitoringRollback: 'Monitoramento e Rollback',

  /* ── Nomes das fases — Solução de Problemas ─────── */
  phaseIdentifying: 'Identificando Problemas',
  phaseReadingLogs: 'Lendo Logs',
  phasePipelineErrors: 'Erros Comuns de Pipeline',
  phaseDebugging: 'Debugging em Runtime',
  phaseEscalation: 'Procedimentos de Escalação',

  /* ── Nomes das fases — Templates ────────────────── */
  phaseTemplateGallery: 'Galeria de Templates',
  phaseCreatingComponent: 'Criando um Componente',
  phaseConfiguring: 'Configurando Parâmetros',
  phaseRepoSetup: 'Configuração do Repositório',
  phaseFirstDeploy: 'Primeiro Deploy',

  /* ── Nomes das fases — Azure ────────────────────── */
  phaseAzureOverview: 'Visão Geral de Recursos Azure',
  phaseKeyVault: 'Configuração do KeyVault',
  phaseStorage: 'Storage Account',
  phaseEventHub: 'Configuração do EventHub',
  phaseResourceMonitoring: 'Monitoramento de Recursos',

  /* ── Nomes das fases — API ──────────────────────── */
  phaseApiStandards: 'Padrões de API',
  phaseScorecard: 'Visão dos Scorecards',
  phaseRegisterApis: 'Registrando APIs',
  phaseCompliance: 'Verificações de Conformidade',
  phaseImprovingScores: 'Melhorando Pontuações',

  /* ── Nomes das fases — Time ─────────────────────── */
  phaseTeamStructure: 'Estrutura do Time',
  phaseRoleAccess: 'Acesso Baseado em Papel',
  phasePermissionPolicies: 'Políticas de Permissão',
  phaseOnboardingMembers: 'Onboarding de Membros',

  /* ── Nomes das fases — Custos ───────────────────── */
  phaseCostDashboard: 'Dashboard de Custos',
  phaseUsageAnalysis: 'Análise de Uso',
  phaseOptimization: 'Dicas de Otimização',
  phaseBudgetAlerts: 'Alertas de Orçamento',

  /* ── Títulos de seção dos passos ────────────────── */
  sectionWelcomePlatform: '1. Boas-vindas e Visão da Plataforma',
  sectionNavigatingBackstage: '2. Navegando no Backstage',
  sectionFindingProject: '3. Encontrando Seu Projeto',
  sectionExternalTools: '4. Visão das Ferramentas Externas',
  sectionPermissionsSecurity: '5. Permissões e Regras de Segurança',
  sectionBeforeStart: '1. Antes de começar',
  sectionCICDPipeline: '2. A pipeline de CI/CD',
  sectionConfiguringApp: '3. Configurando sua aplicação',
  sectionBranchesLive: '4. Branches & colocando em produção',
  sectionMonitoringDeploys: '5. Monitorando seus deploys',

  /* ── Títulos dos passos da jornada ──────────────── */
  stepWelcomeIdp: 'Bem-vindo ao IDP',
  stepToolsAroundYou: 'As ferramentas ao seu redor',
  stepHowItConnects: 'Como tudo se conecta',
  stepHomePage: 'A página inicial',
  stepQuickActions: 'Ações rápidas',
  stepSearchBar: 'A barra de busca',
  stepOpenCatalog: 'Abrir o catálogo',
  stepUnderstandingKinds: 'Entendendo os tipos',
  stepFiltersSearch: 'Filtros e busca',
  stepFindSystem: 'Encontre seu sistema',
  stepSystemOverview: 'Visão do sistema',
  stepRelationsGraph: 'Grafo de relações',
  stepArgoCd: 'ArgoCD: seu painel de deploy',
  stepGrafana: 'Grafana: seus logs',
  stepGitHubAzureDevOps: 'GitHub e Azure DevOps',
  stepPermissionsDeveloper: 'Suas permissões como desenvolvedor',
  stepSecurityRules: 'Regras de segurança (obrigatório)',
  stepJourneyComplete: 'Jornada completa!',
  stepTwoRepositories: 'Dois repositórios, um fluxo',
  stepPlatformHandles: 'O que a plataforma cuida para você',
  stepCompleteFlow: 'O fluxo completo: push até aplicação rodando',
  stepPipelineStages: 'Três estágios da pipeline',
  stepArgoCDAutoDeploy: 'ArgoCD faz deploy automaticamente',
  stepComponentFile: 'O arquivo de componente',
  stepEnvSecrets: 'Variáveis de ambiente & secrets',
  stepResourcesHealth: 'Recursos & health checks',
  stepValidateYAML: 'Valide seu YAML antes de fazer commit',
  stepBranchMapping: 'Qual branch atualiza qual ambiente',
  stepGoingProduction: 'Colocando em produção',
  stepIndependentlyDo: 'O que você pode fazer por conta própria',
  stepCheckingArgoCD: 'Checando deploys em ArgoCD',
  stepCheckingLogs: 'Checando logs em Grafana',

  /* -- Journey 3: When Something Goes Wrong ----------- */
  sectionJ3CheckLogs: '1. Verifique seus logs primeiro',
  stepJ3StartGrafana: 'Comece com Grafana',
  stepJ3WhatToLookLogs: 'O que procurar nos logs',
  sectionJ3CheckDeploy: '2. Verifique seu deploy',
  stepJ3WhenNotInLogs: 'Quando não está nos logs',
  stepJ3GitOpsMisconfiguration: 'Erros de configuração GitOps',
  stepJ3PipelineFailures: 'Falhas no pipeline',
  stepJ3ImageNotUpdating: 'Imagem não atualizando (PullBackOff)',
  sectionJ3AskHelp: '3. Quando pedir ajuda',
  stepJ3OpenTicket: 'Abra um ticket',
  stepJ3Journey3Complete: 'Jornada 3 completa!',

  /* ── Quiz ────────────────────────────────────────── */
  sectionQuiz: 'Quiz',
  stepQuiz: 'Quiz',
  quizQuestionOf: 'Pergunta {{current}}/{{total}}',
  quizConfirm: 'Confirmar',
  quizCorrectAnswer: 'Resposta correta: {{letter}}',
  quizPassed: 'Quiz aprovado!',
  quizFailed: 'Quiz não aprovado',
  quizCorrectAnswers: 'respostas corretas',
  quizNextJourneyUnlocked: 'Jornada 2: Deploy: do código ao ar está desbloqueada!',
  quizNextSteps: 'Você completou todas as três jornadas de Desenvolvedor e passou em todas as validações. Acesso completo à plataforma está desbloqueado.',
  quizContinueToJourney: 'Continuar para Jornada 2',
  quizFinishOnboarding: 'Finalizar Onboarding',
  quizTryAgain: 'Tentar novamente',
  quizStartQuiz: 'Iniciar Quiz',
  quizFailedMessage:
    'Você precisa de pelo menos {{min}} de {{total}} corretas para passar. Revise o conteúdo da jornada e tente novamente. Você pode refazer o quiz quantas vezes precisar.',
  quizReviewJourney: 'Revisar Jornada',
  playgroundGoToPlayground: 'Ir para o Playground',

  /* ── Playground ───────────────────────────────────── */
  sectionPlayground: 'Playground',
  stepPlayground: 'Playground',
  playgroundTitle: 'Hora do Playground!',
  playgroundDescription: 'Agora é a sua vez. Complete as tarefas abaixo no repositório do Playground para validar o que você aprendeu.',
  playgroundTaskListHeader: 'O que você vai fazer:',
  playgroundTask1: 'Clonar o repositório, criar uma branch, fazer uma alteração',
  playgroundTask2: 'Fazer merge para develop e acompanhar a execução do pipeline',
  playgroundTask3: 'Verificar o deploy no ArgoCD (ambiente dv)',
  playgroundTask4: 'Promover para pré-produção via branch release_candidate',
  playgroundTask5: 'Promover para produção via merge para main + aprovação de PR',
  playgroundTutorialLabel: 'Abrir o tutorial completo',
  playgroundTutorialDescription: 'Instruções passo a passo para o exercício',
  playgroundRepoLabel: 'Abrir repositório do playground (BFF)',
  playgroundVerifyHint: 'Quando terminar, clique em Verificar abaixo. Vamos checar se as tarefas foram concluídas.',
  playgroundVerify: 'Verificar',
  playgroundCompleted: 'Playground concluído!',
  playgroundCompletedMessage: 'Verificamos suas ações no repositório. Tudo certo.',
  playgroundNextJourneyUnlocked: 'Jornada 3: Quando Algo Dá Errado está desbloqueada! Você pode iniciá-la pela página de onboarding.',
  playgroundContinueToJourney: 'Continuar para Jornada 3',
  playgroundFailedTitle: 'Não foi possível confirmar a conclusão',
  playgroundFailedMessage: 'Verificamos o repositório do Playground mas não foi possível confirmar que todas as tarefas foram concluídas. Você ainda pode ter ações pendentes.',
  playgroundFailedHint: 'Revise o conteúdo da jornada, certifique-se de que completou todos os passos no repositório, e tente verificar novamente.',
  playgroundReviewJourney: 'Revisar Jornada',
  playgroundVerifyAgain: 'Verificar novamente',

  /* ── Confirmação de saída ─────────────────────────── */
  exitConfirmTitle: 'Sair do onboarding?',
  exitConfirmMessage: 'Seu progresso nesta jornada será perdido. Você pode recomeçar a qualquer momento pela página de trilha.',
  exitConfirmLeave: 'Sair',
  exitConfirmStay: 'Ficar',

  /* ── Seletor de idioma ──────────────────────────── */
  languageLabel: 'Idioma',

  /* ── Pré-requisitos ─────────────────────────────── */
  prerequisitesTitle: 'Pré-requisitos',
  prerequisitesDescription: 'Antes de iniciar o onboarding, certifique-se de que possui as seguintes licenças. Caso não tenha alguma delas, solicite através dos links abaixo.',
  prerequisiteGithubLicense: 'Licença GitHub',
  prerequisiteGithubCopilot: 'Licença GitHub Copilot',
  prerequisiteGithubCodespaces: 'Licença GitHub Codespaces',
  prerequisitesAlignWithTechLead: 'Caso não possua alguma dessas licenças, alinhe também com o seu Tech Lead.',
  prerequisitesRequestAccess: 'Solicitar acesso aqui',
  prerequisitesHowToFill: 'Como preencher a solicitação',

  /* ── NPS ─────────────────────────────────────────── */
  npsTitle: 'Feedback do Onboarding',
  npsDescription: 'Sua opinião é fundamental para melhorarmos a experiência de onboarding do IDP. Esta pesquisa é anônima e leva cerca de 2 minutos. Os resultados orientarão as próximas evoluções da plataforma.',
  npsQuestionsCount: '{{count}} perguntas',
  npsBadge: '+ NPS',
  npsStart: 'Iniciar NPS',
  npsSubmitError: 'Erro ao enviar NPS. Tente novamente.',
  reviewNps: 'Revisar NPS',
  npsThankYouSubtitle: 'Suas respostas foram registradas com sucesso.',
};
